// extracted by mini-css-extract-plugin
module.exports = {"addTaskForm":"AddTaskForm_addTaskForm__2GzER","formElement":"AddTaskForm_formElement__1D132","formButtons":"AddTaskForm_formButtons__v0kUl","error":"AddTaskForm_error__3qiNm"};